import SourcingRequest from '@/shared/infrastructure/sourcing/request'

const actions = {
  async fetchFreelancerCategories({ commit }) {
    const response = await SourcingRequest.fetchFreelancerCategories()
    commit('setFreelancerCategories', response.categories)
  },
  async fetchSourcingRequestSummary(actions, formData) {
    const response = await SourcingRequest.fetchSourcingRequestSummary(formData)
    return response
  },
  async createNewSourcingRequest({ commit }, formData) {
    const response = await SourcingRequest.createNewSourcingRequest(formData)
    if (response.result) {
      commit('setSourcingRequestToken', response.token)
    }
    return response
  },
  async updateClientInformation({ state }, formData) {
    const response = await SourcingRequest.updateClientInformation(formData, state.sourcingRequestToken)
    return response
  },
  async updateProductInformation({ state }, formData) {
    const response = await SourcingRequest.updateProductInformation(formData, state.sourcingRequestToken)
    return response
  },
  async addProductImage({ state }, formData) {
    const response = await SourcingRequest.addProductImage(formData, state.sourcingRequestToken)
    return response
  },
  async removeProductImage({ state }, imageToken) {
    const response = await SourcingRequest.removeProductImage(state.sourcingRequestToken, imageToken)
    return response
  },
  async updateSupplierInformation({ state }, formData) {
    const response = await SourcingRequest.updateSupplierInformation(formData, state.sourcingRequestToken)
    return response
  },
  async linkClientToSourcingRequest({ state }, formData) {
    const response = await SourcingRequest.linkClientToSourcingRequest(formData, state.sourcingRequestToken)
    return response
  },
  async linkPaymentAndAddress({ state }, payload) {
    const response = await SourcingRequest.linkPaymentAndAddressRequest(payload, state.sourcingRequestToken)
    return response
  },
  async completePlaceOrder(actions, link) {
    const response = await SourcingRequest.completePlaceOrderRequest(link)
    return response
  },
  async getSourcingOrderDraftInformation({ state }) {
    const response = await SourcingRequest.getSourcingOrderDraftInformation(state.sourcingRequestToken)
    return response
  }
}

export default actions
